import React, { useLayoutEffect, useRef, useState } from 'react';
import classNameBind from 'classnames/bind';
import styles from './SegmentedSelectionLite.module.css';

const bindClasses = classNameBind.bind(styles);

const SegmentedSelectionLite = ({ value, onChange, items, dataId = 'SegmentedSelectionLite' }) => {
  const itemRefs = useRef([]);
  const [markerStyle, setMarkerStyle] = useState({ left: 0, width: 0 });
  const useFlexibleLayout = items.length && items[0].name !== undefined;
  const getName = item => (useFlexibleLayout ? item.name : item.value);

  useLayoutEffect(() => {
    const index = items.findIndex(item => item.value === value);
    const itemEl = itemRefs.current[index];

    if (itemEl) {
      const left = itemEl.offsetLeft;
      const width = itemEl.offsetWidth;
      setMarkerStyle({ left, width });
    }
  }, [value, items]);

  return (
    <div className={bindClasses('wrapper', { dynamic: useFlexibleLayout })} data-ppuc-id={dataId}>
      <div
        className={bindClasses('selected-marker')}
        style={{ left: `${markerStyle.left}px`, width: `${markerStyle.width}px` }}
        data-ppuc-id={`${dataId}.marker`}
      />
      {items.map((item, index) => {
        const id = item.value;
        const name = getName(item);

        return (
          <div
            key={id}
            ref={(el) => {
              itemRefs.current[index] = el;
            }}
            className={bindClasses('item', { selected: id === value })}
            onClick={() => onChange(id)}
            role="button"
            tabIndex={0}
            data-ppuc-id={`${dataId}.item-${id}`}
          >
            {name}
          </div>
        );
      })}
    </div>
  );
};

export default SegmentedSelectionLite;
